import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Tooltip, TextField } from '@shopify/polaris'
import _ from 'lodash'
import IconClose from 'react-icons/lib/fa/close'

import { setCustomFieldArray } from 'controllers/logic'
import { SHOPIFY_RED, SHOPIFY_GRAY } from 'components/styles'

const Wrapper = styled.div`
  _height: 10em;
  width: 30em;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 2em;
`
const TextFieldContainer = styled.div`
  width: 30em;
  margin-top: 1em;
  display: flex;
  justify-content: center;
  & > div > div > .Polaris-TextField__Backdrop  {
    ${props => props.isEmpty ? `background-color: ${SHOPIFY_GRAY};` : ''}
  }

  & > div  {
    width: 100%;
  }
`
const ClearTextContainer = styled.div`
  color: ${SHOPIFY_RED};
  cursor: pointer;
  margin-right: -0.6em;
  min-width: 1em;

  & > span {
    outline: none;
  }
`


class EditText extends Component {

  onChangeTextInput = path => {
    return (v) => {
      const { dispatch, app } = this.props
      dispatch(setCustomFieldArray(app.id, path, v))
    }
  }

  clearTextField = (path) => {
    return () => {
      const { dispatch, app } = this.props
      dispatch(setCustomFieldArray(app.id, path, ''))
    }
  }

  renderClearTextButton = (path, isEmpty) => {
    if (isEmpty) {
      return <ClearTextContainer />
    } else {
      return (
        <ClearTextContainer onClick={this.clearTextField(path)}>
          <Tooltip
            content='Clear'
            light
          >
            <IconClose />
          </Tooltip>
        </ClearTextContainer>
      )
    }
  }

  onFocus = (i) => {
    return () => {
      this.props.onTextFieldFocus(i)
    }
  }

  render () {
    const { paths, app, template, labels } = this.props
    return (
      <Wrapper>
        {_.map(paths, (path, i) => {
          let value = _.get(app.customFields, path, '')
          if (value === 'empty') value = ''
          if (_.isNil(value)) value = _.get(template.settings, path, '')
          const isEmpty = value === ''
          return (
            <TextFieldContainer key={i} isEmpty={isEmpty}>
              <TextField
                value={value}
                label={_.get(labels, i)}
                onChange={this.onChangeTextInput(path)}
                suffix={this.renderClearTextButton(path, isEmpty)}
                onFocus={this.onFocus(i)}
                onBlur={this.onFocus(-1)}
              />
            </TextFieldContainer>
          )
        })}
      </Wrapper>
    )
  }
}


EditText.propTypes = {
  paths: PropTypes.array.isRequired,
  app: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  onTextFieldFocus: PropTypes.func,
  labels: PropTypes.array
}

export default connect()(EditText)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/EditText.js